<template>

  <ProxyDeleteButton/>

</template>

<script>

import ProxyDeleteButton from './ProxyDeleteButton'

export default {
  name: 'DeleteButton',
  components: {
    ProxyDeleteButton
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/DeleteButton.vue